import Vue from 'vue'
import Router from 'vue-router'
import zhzx from '@/index/zhzx'
import ptjs from '@/index/ptjs'
import spzq from '@/index/spzq'
import zgzs from '@/index/zgzs'
import zstd from '@/index/zstd'
import zygx from '@/index/zygx'
import gywm from '@/index/gywm'
import index from '@/index/index'
import hysy from '@/tqhy/hysy.vue'
import hyjb from '@/tqhy/hyjb.vue'
import tqhy from '@/tqhy/tqhy.vue'
import sphf from '@/tqhy/sphf.vue'
import zbhf from '@/zb/zbhf.vue'
import zbyg from '@/zb/zbyg.vue'
import zzzb from '@/zb/zzzb.vue'
import productDetail from '@/detail/productDetail.vue'
import zsDetail from '@/detail/zsDetail.vue'
import zpDetail from '@/detail/zpDetail.vue'
import wzDetail from '@/detail/wzDetail.vue'
import spDetail from '@/detail/spDetail.vue'
import search from '@/components/search.vue'
import register from '@/components/register.vue'
import Layout from '@/layout/index.vue'
Vue.use(Router)


const routes = [
	{
		path: '/',
		name: 'Index',
		redirect: '/site/index'
	},
	// {
	// 	path: '/index',
	//     name: 'index',
	//     component: index,
	//     hidden:true
	// },
	// {
	// 	path: '/zhzx',
	//     name: 'zhzx',
	//     component: zhzx,
	//     hidden:true
	// },
	// {
	// 	path: '/spzq',
	//     name: 'spzq',
	//     component: spzq,
	//     hidden:true
	// },
	// {
	// 	path: '/zgzs',
	//     name: 'zgzs',
	//     component: zgzs,
	//     hidden:true
	// },
	// {
	// 	path: '/zstd',
	//     name: 'zstd',
	//     component: zstd,
	//     hidden:true
	// },
	// {
	// 	path: '/hysy',
	//     name: 'hysy',
	//     component: hysy,
	//     hidden:true
	// },
	// {
	// 	path: '/tqhy',
	//     name: 'tqhy',
	//     component: tqhy,
	//     hidden:true
	// },
	// {
	// 	path: '/sphf',
	//     name: 'sphf',
	//     component: sphf,
	//     hidden:true
	// },
	// {
	// 	path: '/hyjb',
	//     name: 'hyjb',
	//     component: hyjb,
	//     hidden:true
	// },
	// {
	// 	path: '/zygx',
	//     name: 'zygx',
	//     component: zygx,
	//     hidden:true
	// },
	// {
	// 	path: '/productDetail',
	//     name: 'productDetail',
	//     component: productDetail,
	//     hidden:true
	// },
	// {
	// 	path: '/zsDetail',
	//     name: 'zsDetail',
	//     component: zsDetail,
	//     hidden:true
	// },
	// {
	// 	path: '/ptjs',
	//     name: 'ptjs',
	//     component: ptjs,
	//     hidden:true
	// },
	// {
	// 	path: '/gywm',
	//     name: 'gywm',
	//     component: gywm,
	//     hidden:true
	// },
	// {
	// 	path: '/search',
	//     name: 'search',
	//     component: search,
	//     hidden:true
	// },
	// {
	// 	path: '/wzDetail',
	//     name: 'wzDetail',
	//     component: wzDetail,
	//     hidden:true
	// },
	// {
	// 	path: '/zpDetail',
	//     name: 'zpDetail',
	//     component: zpDetail,
	//     hidden:true
	// },
	// {
	// 	path: '/zzzb',
	//     name: 'zzzb',
	//     component: zzzb,
	//     hidden:true
	// },
	// {
	// 	path: '/zbhf',
	//     name: 'zbhf',
	//     component: zbhf,
	//     hidden:true
	// },
	// {
	// 	path: '/zbyg',
	//     name: 'zbyg',
	//     component: zbyg,
	//     hidden:true
	// },
	// {
	// 	path: '/register',
	//     name: 'register',
	//     component: register,
	//     hidden:true
	// },
	{
		path: '/site',
		name: 'Home',
		component: Layout,
		redirect: '/site/index',
		children: [
			{
				path: 'index',
				name: 'HomeIndex',
				component: () => import('@/views/index/index.vue'),
			},
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/index/login.vue'),
      },
      {
        path: 'audienceRegister',
        name: 'AudienceRegister',
        component: () => import('@/index/audienceRegister.vue'),
      },
			{
				path: 'information',
				name: 'ExhibitionInfo',
				component: () => import('@/index/zhzx.vue'),
			},
			{
				path: 'spzq',
				name: 'spzq',
				component: () => import('@/index/spzq.vue'),
			},
			{
				path: 'zgzs',
				name: 'zgzs',
				component: () => import('@/index/zgzs.vue'),
			},
			{
				path: 'zstd',
				name: 'zstd',
				component: () => import('@/index/zstd.vue'),
			},
			{
				path: 'hysy',
				name: 'hysy',
				component: () => import('@/tqhy/hysy.vue'),
			},
			{
				path: 'tqhy',
				name: 'tqhy',
				component: () => import('@/tqhy/tqhy.vue'),
			},
			{
				path: 'sphf',
				name: 'sphf',
				component: () => import('@/tqhy/sphf.vue'),
			},
			{
				path: 'hyjb',
				name: 'hyjb',
				component: () => import('@/tqhy/hyjb.vue'),
			},
			{
				path: 'zygx',
				name: 'zygx',
				component: () => import('@/index/zygx.vue'),
			},
			{
				path: 'productDetail',
				name: 'productDetail',
				component: () => import('@/detail/productDetail.vue'),
			},
			{
				path: 'zsDetail',
				name: 'zsDetail',
				component: () => import('@/detail/zsDetail.vue'),
			},
			{
				path: 'ptjs',
				name: 'ptjs',
				component: () => import('@/index/ptjs.vue'),
			},
			{
				path: 'gywm',
				name: 'gywm',
				component: () => import('@/index/gywm.vue'),
			},
			{
				path: 'search',
				name: 'search',
				component: () => import('@/components/search.vue'),
			},
			{
				path: 'wzDetail',
				name: 'wzDetail',
				component: () => import('@/detail/wzDetail.vue'),
			},
			{
				path: 'zpDetail',
				name: 'zpDetail',
				component: () => import('@/detail/zpDetail.vue'),
			},
			{
				path: 'spDetail',
				name: 'spDetail',
				component: () => import('@/detail/spDetail.vue'),
			},
			{
				path: 'zzzb',
				name: 'zzzb',
				component: () => import('@/zb/zzzb.vue'),
			},
			{
				path: 'zbhf',
				name: 'zbhf',
				component: () => import('@/zb/zbhf.vue'),
			},
			{
				path: 'zbyg',
				name: 'zbyg',
				component: () => import('@/zb/zbyg.vue'),
			},
			{
				path: 'register',
				name: 'register',
				component: () => import('@/index/register.vue'),
			},



		],
	},
];
const router = new Router({
// 	mode: "history",
	base: process.env.BASE_URL,
	routes,
});
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router;
